import { Field } from '@elotech/components';

import { CamposDosFiltros } from '../../utils/InscricaoCadastralUtils';

export const camposImobiliario: Field[] = [
  {
    label: 'Cadastro',
    name: 'cadastroGeral',
    type: 'STRING'
  },
  {
    label: 'Cadastro Anterior',
    name: 'cadastroGeralAnterior',
    type: 'STRING'
  },
  {
    label: 'Inscrição Cadastral',
    name: 'inscricaoCadastral',
    type: 'STRING'
  },
  {
    label: 'Inscrição Anterior',
    name: 'inscricaoCadastralAnterior',
    type: 'STRING'
  },
  {
    label: 'Matrícula',
    name: 'matricula',
    type: 'STRING'
  },
  {
    label: 'Cartório',
    name: 'cartorio',
    type: 'STRING'
  },
  {
    label: 'Proprietário',
    name: 'pessoa.nome_sort',
    type: 'STRING'
  },
  {
    label: 'CNPJ/CPF',
    name: 'pessoa.cnpjCpf',
    type: 'STRING'
  },
  {
    label: 'Endereço',
    name: 'enderecoFormatado',
    type: 'STRING'
  },
  {
    label: 'Bairro (Código)',
    name: 'bairro.bairro',
    type: 'STRING'
  },
  {
    label: 'Bairro (Descrição)',
    name: 'bairro.descricao',
    type: 'STRING'
  },
  {
    label: 'Quadrícula',
    name: 'quadriculaLocalizacao.descricaoQuadricula_sort',
    type: 'STRING'
  },
  {
    label: 'Distrito (Código)',
    name: 'distritoLocalizacao.distrito_sort',
    type: 'STRING'
  },
  {
    label: 'Distrito (Descrição)',
    name: 'distritoLocalizacao.descricao',
    type: 'STRING'
  },
  {
    label: 'Setor/Zona',
    name: 'setorLocalizacao.setor',
    type: 'STRING'
  },
  {
    label: 'Loteamento',
    name: 'loteamento.descricao',
    type: 'STRING'
  },
  {
    label: 'Condominio',
    name: 'condominio.descricao',
    type: 'STRING'
  },
  {
    label: 'Área do Lote',
    name: 'areaLoteValor',
    type: 'STRING'
  },
  {
    label: 'Área Total Construída',
    name: 'areaTotalConstruidaValor',
    type: 'STRING'
  },
  {
    label: 'Quadra',
    name: 'quadraLocalizacao.quadra',
    type: 'STRING'
  },
  {
    label: 'Lote',
    name: 'loteLocalizacao_sort',
    type: 'STRING'
  },
  {
    label: 'Unidade',
    name: 'unidadeLocalizacao_sort',
    type: 'STRING'
  },
  {
    label: 'Quadra Fiscal',
    name: 'quadraFiscalizacao',
    type: 'STRING'
  },
  {
    label: 'Lote Fiscal',
    name: 'loteFiscalizacao',
    type: 'STRING'
  },
  {
    label: 'Tipo Imóvel',
    name: 'tipoImovelDescricao',
    type: 'STRING'
  },
  {
    label: 'Tipo Lote',
    name: 'tipoLoteDescricao',
    type: 'STRING'
  },
  {
    label: 'Complemento Endereço',
    name: 'complemento',
    type: 'STRING'
  },
  {
    label: 'Complemento Lote',
    name: 'complementoLote',
    type: 'STRING'
  },
  {
    label: 'Situação',
    name: 'situacaoDescricao',
    type: 'STRING'
  }
];

export const camposRural: Field[] = [
  {
    label: 'Cadastro',
    name: 'cadastroGeral',
    type: 'STRING'
  },
  {
    label: 'Cadastro Anterior',
    name: 'cadastroGeralAnterior',
    type: 'STRING'
  },
  {
    label: 'Matrícula',
    name: 'matricula',
    type: 'STRING'
  },
  {
    label: 'Proprietário',
    name: 'pessoa.nome_sort',
    type: 'STRING'
  },
  {
    label: 'Endereço',
    name: 'endereco',
    type: 'STRING'
  },
  {
    label: 'Bairro',
    name: 'bairro.descricao',
    type: 'STRING'
  },
  {
    label: 'Distrito (Código)',
    name: 'distrito.distrito_sort',
    type: 'STRING'
  },
  {
    label: 'Distrito (Descrição)',
    name: 'distrito.descricao',
    type: 'STRING'
  },
  {
    label: 'Setor',
    name: 'setor.setor',
    type: 'STRING'
  },
  {
    label: 'Lote',
    name: 'lote',
    type: 'STRING'
  }
];

/**
 * Filtros de localização do cadastro imobiliário e o campo da configuração de Inscrição
 * Cadastral que cada um representa (mesmo mapeamento do Tributos, InscricaoCadastralLabels).
 */
export const camposLocalizacaoFiltrosImobiliario: CamposDosFiltros = {
  'quadriculaLocalizacao.descricaoQuadricula_sort': { campo: 'quadricula' },
  'distritoLocalizacao.distrito_sort': {
    campo: 'distrito',
    sufixo: ' (Código)'
  },
  'distritoLocalizacao.descricao': {
    campo: 'distrito',
    sufixo: ' (Descrição)'
  },
  'setorLocalizacao.setor': { campo: 'setor' },
  'quadraLocalizacao.quadra': { campo: 'quadra' },
  loteLocalizacao_sort: { campo: 'lote' },
  unidadeLocalizacao_sort: { campo: 'unidade' }
};

/** Filtros de localização do cadastro rural e o campo da configuração que cada um representa. */
export const camposLocalizacaoFiltrosRural: CamposDosFiltros = {
  'distrito.distrito_sort': { campo: 'distrito', sufixo: ' (Código)' },
  'distrito.descricao': { campo: 'distrito', sufixo: ' (Descrição)' },
  'setor.setor': { campo: 'setor' },
  lote: { campo: 'lote' }
};
